import { render, staticRenderFns } from "./delivered.vue?vue&type=template&id=8f8eb3ba&scoped=true&"
import script from "./delivered.vue?vue&type=script&lang=js&"
export * from "./delivered.vue?vue&type=script&lang=js&"
import style0 from "./delivered.vue?vue&type=style&index=0&id=8f8eb3ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8eb3ba",
  null
  
)

export default component.exports